import React, { useState } from "react";
import { TextField, Button, Box, Typography, Paper } from "@mui/material";
import axios from "axios";

const AuthenticationForm = ({ onAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
      const response = await axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${apiKey}`,
        {
          email: email,
          password: password,
          returnSecureToken: true,
          clientType: "CLIENT_TYPE_WEB",
        }
      );

      const { idToken, refreshToken } = response.data;

      localStorage.setItem("authToken", idToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("loginTimestamp", Date.now().toString());

      // Notify parent component about authentication success
      onAuthenticated(idToken);
    } catch (error) {
      setError("Invalid email or password");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top center, rgba(255, 192, 155, 0.20), rgba(255,255,255,0) 34%), linear-gradient(180deg, #fffaf6 0%, #fdf6f2 36%, #f8f9fc 100%)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          mx: { xs: 1.5, sm: 2 },
          borderRadius: { xs: 3, sm: 4, md: 6 },
          background:
            "radial-gradient(circle at top center, rgba(255, 191, 154, 0.28), rgba(255,255,255,0.94) 42%), linear-gradient(180deg, rgba(255, 248, 243, 0.96), rgba(255, 255, 255, 0.92))",
          boxShadow: "0 24px 60px rgba(236, 123, 55, 0.10)",
          border: "1px solid rgba(255, 132, 76, 0.10)",
          p: { xs: 2.5, sm: 4, md: 5 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 3.5,
          }}
        >
          <Box
            component="img"
            src="https://devstoragegreenback.blob.core.windows.net/dev-image-container/logo-preezie.png"
            alt="Preezie"
            sx={{
              width: 48,
              height: 48,
              borderRadius: "4px",
              objectFit: "contain",
              mb: 2,
            }}
          />
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "#202531",
              letterSpacing: "-0.03em",
              mb: 0.8,
            }}
          >
            preezie
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#6b7280",
              fontWeight: 500,
            }}
          >
            Sign in to Preezie Management
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: "24px",
            border: "1px solid rgba(255, 132, 76, 0.10)",
            backgroundColor: "rgba(255,255,255,0.88)",
            boxShadow: "0 20px 44px rgba(236, 123, 55, 0.08)",
          }}
        >
          <TextField
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "14px",
                backgroundColor: "rgba(255,255,255,0.82)",
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(255, 139, 71, 0.4)",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ff8b47",
                },
              },
            }}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: "14px",
                backgroundColor: "rgba(255,255,255,0.82)",
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(255, 139, 71, 0.4)",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ff8b47",
                },
              },
            }}
          />
          <Button
            fullWidth
            onClick={handleLogin}
            sx={{
              background: "linear-gradient(180deg, #ffb58d 0%, #ff8b47 100%)",
              boxShadow: "0 14px 28px rgba(255, 139, 71, 0.28)",
              borderRadius: "14px",
              color: "#fff",
              fontWeight: 700,
              py: 1.4,
              fontSize: "1rem",
              textTransform: "none",
              "&:hover": {
                background: "linear-gradient(180deg, #ffa97b 0%, #ff7c34 100%)",
                boxShadow: "0 18px 36px rgba(255, 139, 71, 0.34)",
              },
            }}
          >
            Login
          </Button>
          {error && (
            <Typography color="error" mt={2} textAlign="center" fontWeight={500}>
              {error}
            </Typography>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default AuthenticationForm;
